'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('oddCampaignModule')
    .factory('oddCampaignService', ['$http', '$q', function ($http) {
        var oddBaseUrl = environment.apiUrl + '/Pilot/api/ODD/BusinessUnit';
        var surveyBaseUrl = environment.apiUrl + '/Pilot/api/SurveyV2/BusinessUnit';


        return {
            getAllCampaignsByBusinessUnitAndExtParty: function (bUnitId, extPartyId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign';

                return $http
                        .get(reqUrl)
                        .then(function (response) { return response.data; })
            },
            getAllCampaignsByBusinessUnit: function (bUnitId) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign';
                return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        })
            },
            getCampaign: function (bUnitId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId;
                return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        })
            },

            // Get Available Questionnaires
            getAvailableQuestionnaires: function (bUnitId) {
                return $http
                    .get(oddBaseUrl + '/' + bUnitId + '/Campaign/Questionnaire')
                    .then(function (response) { return response.data; })
            },

            getSurveyCampaign: function (bUnitId, campaignId) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId;
                return $http
                        .get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        })
            },

            preFillCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/PreFill';

                return $http
                        .post(reqUrl)
                        .then(function (response) { return response.data; })
            },

            publishCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Publish';

                return $http
                        .post(reqUrl)
                        .then(function (response) { return response.data; })
            },
            publishSurveyCampaign: function (bUnitId, campaignId) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId + '/Publish';

                return $http
                        .post(reqUrl)
                        .then(function (response) { return response.data; })
            },
            unpublishCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Unpublish';

                return $http
                        .post(reqUrl)
                        .then(function (response) { return response.data; })
            },

            unpublishSurveyCampaign: function (bUnitId, campaignId) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId + '/Unpublish';

                return $http
                        .post(reqUrl)
                        .then(function (response) { return response.data; })
            },

            previewCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Preview';

                return $http
                    .post(reqUrl)
                    .then(function (response) { return response.data; });
            },

            cancelPreviewCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/CancelPreview';

                return $http
                    .post(reqUrl)
                    .then(function (response) { return response.data; });
            },

            deleteCampaign: function (bUnitId, extPartyId, campaignId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId;

                return $http
                        .delete(reqUrl)
                        .then(function (response) { return response.data; })
            },
            deleteSurveyCampaign: function (bUnitId, campaignId) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId;

                return $http
                        .delete(reqUrl)
                        .then(function (response) { return response.data; })
            },

            createCampaign: function (bUnitId, extPartyId, campaign) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign';

                return $http
                        .post(reqUrl, campaign)
                        .then(function (response) {

                            return response.data;
                        })
            },
            createODDCampaignInviteDetails: function (bUnitId, extPartyId, campaignId, inviteDetails) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/InviteDetails';

                return $http
                        .post(reqUrl, inviteDetails)
                        .then(function (response) {
                            return response.data;
                        })
            },
            updateODDCampaignInviteDetails: function (bUnitId, extPartyId, campaignId, inviteDetails) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/InviteDetails/' + inviteDetails.ODDInviteDetailsID;

                return $http
                        .put(reqUrl, inviteDetails)
                        .then(function (response) {
                            return response.data;
                        });
            },

            // Survey
            createSurveyCampaign: function (bUnitId, campaign) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign';

                return $http
                        .post(reqUrl, campaign)
                        .then(function (response) {

                            return response.data;
                        })
            },
            updateCampaignInviteDetails: function (bUnitId, campaignId, inviteDetails) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId + '/InviteDetails/' + inviteDetails.ODDInviteDetailsID;

                return $http
                        .put(reqUrl, inviteDetails)
                        .then(function (response) {
                            return response.data;
                        })
            },
            createCampaignInviteDetails: function (bUnitId, campaignId, inviteDetails) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId + '/InviteDetails';

                return $http
                        .post(reqUrl, inviteDetails)
                        .then(function (response) {
                            return response.data;
                        })
            },
            updateCampaign: function (bUnitId, extPartyId, campaign) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaign.ODDCampaignID;

                return $http
                        .put(reqUrl, campaign)
                        .then(function (response) { return response.data; })
            },
            updateSurveyCampaign: function (bUnitId, campaign) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaign.ODDCampaignID;

                return $http
                        .put(reqUrl, campaign)
                        .then(function (response) { return response.data; })
            },
            duplicateSurveyCampaign: function (bUnitId, campaignId, title) {
                var reqUrl = surveyBaseUrl + '/' + bUnitId + '/Campaign/' + campaignId + '/Duplicate';

                return $http
                        .post(reqUrl, { titleEN: title })
                        .then(function (response) { return response.data; })
            },

            // Questionnaire

            createQuestionnaire: function (bUnitId, extPartyId, campaignId, questionnaire) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire';

                return $http
                    .post(reqUrl, questionnaire)
                    .then(function (response) { return response.data; })
            },
            getQuestionnaire: function (bUnitId, extPartyId, campaignId, questionnaireId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },
            deleteQuestionnaire: function (bUnitId, extPartyId, campaignId, questionnaireId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },
            orderQuestionnaires: function (bUnitId, extPartyId, campaignId, questionnaires) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/Order';

                return $http
                    .put(reqUrl, questionnaires)
                    .then(function (response) { return response.data; })
            },

            createSection: function (bUnitId, extPartyId, campaignId, questionnaireId, section) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId + '/Section';

                return $http
                    .post(reqUrl, section)
                    .then(function (response) { return response.data; })
            },
            getSection: function (bUnitId, extPartyId, campaignId, questionnaireId, sectionId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },
            deleteSection: function (bUnitId, extPartyId, campaignId, questionnaireId, sectionId) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },
            orderSections: function (bUnitId, extPartyId, campaignId, questionnaireId, sections) {
                var reqUrl = oddBaseUrl + '/' + bUnitId + '/ExternalParty/' + extPartyId + '/Campaign/' + campaignId + '/Questionnaire/' + questionnaireId + '/Section/Order';

                return $http
                    .put(reqUrl, sections)
                    .then(function (response) { return response.data; })
            }

        };
    }]);
